/**
 * Camera Intelligence — theme-side tracker
 *
 * Complements the Shopify Custom Pixel by capturing on-page micro-conversions
 * that don't fire native pixel events:
 *   - PDP plan toggle (Deposit vs Pay Early)
 *   - PDP variant toggle (Body only vs Body+Lens, Black vs Silver)
 *   - Exit popup shown / dismissed / submitted
 *   - Scroll depth 25/50/75/100 (PDP and home)
 *   - Sticky-ATC click on mobile
 *   - Comparison-page CTA click
 *
 * All events are pushed straight to window.dataLayer (GTM picks them up).
 * Standard GA4 event names where possible so existing GA4 tags work without changes.
 */
(function () {
  'use strict';
  if (window.ciThemeTrackerLoaded) return;
  window.ciThemeTrackerLoaded = true;

  window.dataLayer = window.dataLayer || [];
  function push(event, payload) {
    try {
      window.dataLayer.push(Object.assign({ event: event, ts: Date.now() }, payload || {}));
    } catch (e) { /* swallow */ }
  }

  // ---- 1. PDP plan + variant toggles ---------------------------------------
  function trackPlanToggle() {
    document.addEventListener('change', function (e) {
      if (!e.target || !e.target.matches) return;
      // Selling-plan radios
      if (e.target.matches('input[name="selling_plan"], input.pp-selling-plans__radio')) {
        var label = '';
        var wrap = e.target.closest('label');
        if (wrap) label = (wrap.textContent || '').trim();
        push('ci_plan_selected', {
          plan_label: label.slice(0, 60),
          plan_value: /pay early/i.test(label) ? 'pay_early' : (/deposit/i.test(label) ? 'deposit' : 'unknown'),
        });
      }
    }, true);

    // Variant pill clicks (variant change is observable via URL change too —
    // covered by the URL observer below)
    document.addEventListener('click', function (e) {
      var pill = e.target && e.target.closest && e.target.closest('variant-pill, .variant-pill');
      if (!pill) return;
      var lbl = (pill.textContent || '').trim();
      push('ci_variant_clicked', { label: lbl.slice(0, 80) });
    }, true);
  }

  function trackVariantUrlChange() {
    var lastVariant = new URL(location.href).searchParams.get('variant');
    function check() {
      var v = new URL(location.href).searchParams.get('variant');
      if (v && v !== lastVariant) {
        push('ci_variant_changed', { variant_id: v });
        lastVariant = v;
      }
    }
    var pushState = history.pushState;
    history.pushState = function () { pushState.apply(this, arguments); check(); };
    var replaceState = history.replaceState;
    history.replaceState = function () { replaceState.apply(this, arguments); check(); };
    window.addEventListener('popstate', check);
  }

  // ---- 2. Scroll depth -----------------------------------------------------
  function trackScrollDepth() {
    var seen = {};
    var thresholds = [25, 50, 75, 100];
    var pageType = /\/products\//.test(location.pathname) ? 'pdp'
                 : location.pathname === '/' ? 'home'
                 : 'other';
    function check() {
      var doc = document.documentElement;
      var scrollable = doc.scrollHeight - window.innerHeight;
      if (scrollable <= 0) return;
      var pct = Math.round((window.scrollY / scrollable) * 100);
      thresholds.forEach(function (t) {
        if (pct >= t && !seen[t]) {
          seen[t] = true;
          push('ci_scroll_depth', { depth: t, page_type: pageType });
        }
      });
    }
    window.addEventListener('scroll', check, { passive: true });
  }

  // ---- 3. Sticky ATC click on mobile ---------------------------------------
  function trackStickyAtc() {
    document.addEventListener('click', function (e) {
      var btn = e.target && e.target.closest && e.target.closest('.ci-sticky-atc, [data-ci-sticky-atc]');
      if (!btn) return;
      push('ci_sticky_atc_clicked', {});
    }, true);
  }

  // ---- 4. Comparison-page CTA click ----------------------------------------
  function trackComparisonCta() {
    document.addEventListener('click', function (e) {
      var a = e.target && e.target.closest && e.target.closest('a.ci-vs-cta, .ci-comparison-cta');
      if (!a) return;
      push('ci_comparison_cta_clicked', { href: a.getAttribute('href') });
    }, true);
  }

  // ---- 5. Exit popup events ------------------------------------------------
  function trackExitPopup() {
    document.addEventListener('click', function (e) {
      if (!e.target) return;
      if (e.target.closest('[data-ci-exit-close]')) {
        push('ci_exit_popup_dismissed', {});
      }
    }, true);
    document.addEventListener('submit', function (e) {
      var f = e.target;
      if (f && f.matches && f.matches('[data-ci-exit-form]')) {
        push('ci_exit_popup_submitted', {});
      }
    }, true);
    // First-show: observe DOM for the popup becoming visible
    var seen = false;
    var iv = setInterval(function () {
      if (seen) return clearInterval(iv);
      var p = document.getElementById('ci-exit-popup');
      if (p && p.style.display !== 'none' && p.offsetParent) {
        seen = true;
        push('ci_exit_popup_shown', {});
      }
    }, 1000);
  }

  // ---- Init ----------------------------------------------------------------
  function init() {
    trackPlanToggle();
    trackVariantUrlChange();
    trackScrollDepth();
    trackStickyAtc();
    trackComparisonCta();
    trackExitPopup();
    // Fire a page_view that includes page_type so reports can segment PDP vs home
    push('ci_page_view', {
      page_type: /\/products\//.test(location.pathname) ? 'pdp'
               : location.pathname === '/' ? 'home'
               : 'other',
      path: location.pathname,
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
